import { IconName } from "@ailibs/feather-react-ts";
import { PermissionConsts } from "src/permissions/permissionConsts";

export interface MenuListProp {
  icon?: IconName;
  name: string;
  link?: string;
  className?: string;
  permission?: string[];
  subItems?: MenuListProp[];
}
export const MenuList: MenuListProp[] = [
  {
    name: "Menu",
    className: "menu-title",
  },
  {
    icon: "home",
    name: "Menu.Dashboard",
    link: "/dashboard",
  },
  {
    icon: "file",
    name: "Menu.Agreements",
    link: "/agreements",
  },
  {
    icon: "file-text",
    name: "Menu.LegalDocuments",
    link: "/legal-documents",
  },
  {
    icon: "video",
    name: "Menu.TutorialVideos",
    link: "/tutorials",
  },
  {
    icon: "mail",
    name: "Menu.Subscriptions",
    link: "/subscriptions",
  },
  {
    icon: "message-circle",
    name: "Menu.Ticket",
    link: "/ticket/all",
  },
  {
    icon: "users",
    name: "Menu.Clients",
    link: "/#",
    subItems: [
      {
        name: "Menu.Clients",
        link: "/clients",
      },
      {
        // V2 Faz E — onboarding kararı yalnız burada verilir.
        name: "Menu.ClientOnboardings",
        link: "/client-onboardings",
      },
      {
        name: "Menu.ClientsDefinitions",
        link: "/#",
        subItems: [
          {
            name: "Menu.ClientCalllogStatuses",
            link: "/calllog-status",
          },
          {
            name: "Menu.ClientCancellationReasons",
            link: "/clients/cancellation-reasons",
          },
        ],
      },
    ],
  },

  {
    icon: "phone-incoming",
    name: "Menu.Contact",
    link: "/contacts",
  },
  {
    icon: "globe",
    name: "Menu.ContractDefinitions",
    link: "/#",
    subItems: [
      {
        name: "Menu.ContractStatuses",
        link: "/contract/statuses",
      },

      {
        name: "Menu.ContractAssetStatuses",
        link: "/contract/asset-statuses",
      },
      {
        name: "Menu.ContractSource",
        link: "/contract/sources",
      },
      {
        name: "Menu.ContractTypes",
        link: "/contract/types",
      },
      {
        name: "Menu.ContractTransactionTypes",
        link: "/contract/transaction-types",
      },

      {
        name: "Menu.ContractCancellationReasons",
        link: "/contract/cancellation-reasons",
      },
      {
        name: "Menu.ContractDiscountPlans",
        link: "/contract/discount-plans",
      },
      {
        name: "Menu.ContractDamageDefinitions",
        link: "/contract/damage-definitions",
      },
      {
        name: "Menu.ContractPickupDropOffDefinitions",
        link: "/contract/pickup-dropoff-definitions",
      },
    ],
  },
  {
    icon: "globe",
    name: "Menu.WebDefinitions",
    link: "/#",
    subItems: [
      {
        name: "Pazarlama Sitesi V2",
        link: "/web/marketing-v2",
      },
      {
        name: "Menu.Packages",
        link: "/web/packages",
      },

      {
        name: "Menu.Spesifications",
        link: "/web/spesifications",
      },

      {
        name: "Menu.HowToUses",
        link: "/web/howtouses",
      },
      {
        name: "Menu.Faqs",
        link: "/web/faqs",
      },
      {
        name: "Menu.Testimonials",
        link: "/testimonials",
      },
      {
        name: "Menu.BankAccounts",
        link: "/bankaccounts",
      },
    ],
  },

  {
    icon: "file-text",
    name: "Menu.ExtraServices",
    link: "/#",
    subItems: [
      {
        name: "Menu.ExtraServices",
        link: "/extra-services",
      },

      {
        name: "Menu.ExtraServiceGroups",
        link: "/extra-services/groups",
      },
    ],
  },
  {
    icon: "file-text",
    name: "Menu.AssetDefinitions",
    link: "/#",
    subItems: [
      {
        name: "Menu.AssetTypes",
        link: "/asset/types",
      },
      {
        name: "Menu.AssetBrands",
        link: "/asset/brands",
      },
      {
        name: "Menu.AssetGroups",
        link: "/asset/groups",
      },
      {
        name: "Menu.AssetFeatures",
        link: "/asset/features",
      },
    ],
  },
  {
    icon: "file-text",
    name: "Menu.MaintenanceDefinitions",
    link: "/#",
    subItems: [
      {
        name: "Menu.SupplierTypes",
        link: "/maintenance/supplier-types",
      },
      {
        name: "Menu.MaintenanceStatuses",
        link: "/maintenance/statuses",
      },

      {
        name: "Menu.MaintenanceTypes",
        link: "/maintenance/types",
      },
    ],
  },
  {
    icon: "file-text",
    name: "Menu.Definitions",
    link: "/#",
    subItems: [
      {
        name: "Menu.OfficeGroups",
        link: "/office-groups",
      },
      {
        name: "Menu.Sectors",
        link: "/sectors",
      },
      {
        // V2 Faz F — ontoloji artık KT veritabanında, buradan yönetiliyor.
        name: "Menu.Ontology",
        link: "/ontology",
      },
      {
        // V2 Faz F — güven/risk operasyonu Ai admin-panel'den taşındı.
        name: "Menu.Trust",
        link: "/trust",
      },
      {
        name: "Menu.SystemStatus",
        link: "/system-status",
      },
      {
        name: "Menu.FileTypes",
        link: "/file-types",
      },
      {
        name: "Menu.ReminderSubjects",
        link: "/reminder-subjects",
      },
      {
        name: "Menu.UygunaKiralaLocations",
        link: "/uyguna-kirala/locations",
      },
      {
        name: "Menu.FinancialAccountTypes",
        link: "/financial-account-types",
      },
      {
        name: "Menu.Tax",
        link: "/taxes",
      },
    ],
  },
  {
    icon: "settings",
    name: "Menu.Settings",
    link: "/#",
    subItems: [
      {
        name: "Menu.Users",
        link: "/users",
      },
      {
        name: "Menu.PaymentProvider",
        link: "/payment-provider",
      },
      {
        name: "Menu.EmailSettings",
        link: "/email-settings",
      },
      {
        name: "Menu.MailProvisioning",
        link: "/mail-provisioning",
      },
    ],
  },
];
